import {IODirection} from "../Enum/IODirection";
import {FactoryGameType} from "../types";
import {createContext, useContext} from "react";

export type ItemStackContextType = {
    item: string,
    amount: number,
    direction?: IODirection,
    gameType: FactoryGameType,
}

export const ItemStackContext = createContext<ItemStackContextType>(null);

export function useItemStackContext() {
    return useContext(ItemStackContext);
}
